// extracted by mini-css-extract-plugin
export default {"input":"Hea-z","button":"Iea-z","selected":"Jea-z","unavailable":"Kea-z","oos":"Lea-z","paperCutDisabledOverlay":"Mea-z","image":"Nea-z"};